export const API = {
    dipmal: `/dipmal`,
    communications: `/communications`,
    support: `/support`,
    typesall: `/typesall`,
    dimension: `/dimension`,
    public: `/public`,
    donor: `/donor`,
    socialEntity: `/social-entity`,
    contents: `/contents`,
    customer: `/customer`,
    customers: `/customers`,
    config: `/campaign/config`,
    preRestorePwd: `/pre-restore-pwd`,
    donations: `/donations`,
    rations: `/rations`,
    search: `/search`,
    catalogs: `/catalogs`,
    status: `/status`,
    setDelivery: `/set-delivery`,
    beneficiaries: `/beneficiaries`
};